import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifyService } from '@app/services/notify.service';
import { TrainingProgramForm } from '@forms/training/components';
import { TrainingProgram } from '@models/training/training-program.model';
import { RelationsUpdate } from '@training/services/form-file-manager.service';

@Component({
    templateUrl: './training-program-store.template.html',
    styleUrls: ['./training-program-store.style.scss'],
})
export class TrainingProgramFormView extends FormData implements OnInit {
    @ViewChild('trainingProgramForm') trainingProgramForm: TrainingProgramForm;

    isLoading = false;

    program: TrainingProgram = new TrainingProgram();

    constructor(
        private route: ActivatedRoute,
        private notify: NotifyService,
        private router: Router
    ) {
        super();
        if (this.route.snapshot.url[this.route.snapshot.url.length - 1].path !== 'new') {
            this.program = this.route.snapshot.data.models.get('trainingProgram');
        }
    }

    ngOnInit(): void {
        this.isLoading = false;
    }

    onSave(trainingProgramForm: TrainingProgramForm): void {
        trainingProgramForm.submit();

        if (trainingProgramForm.form.invalid) {
            return;
        }

        this.isLoading = true;
        this.trainingProgramForm.fileManager.getRelations().then((fileRelations: RelationsUpdate) => {
            this.program.attach('files', fileRelations.attach);
            this.program.detach('files', fileRelations.detach);
            const isEdit = this.program.id !== null;
            this.program
                .save()
                .then((_) => {
                    if (isEdit) {
                        this.notify.success('training.editSuccessfulMessage');
                        this.router.navigate(['/training', 'programs', this.program.id]);
                        return;
                    }
                    this.notify.success('training.trainingCreatedSuccessfulMessage');
                    this.router.navigate(['/training', 'programs']);
                })
                .catch((err) => {
                    this.notify.error(err.message);
                    this.isLoading = false;
                });
        });
    }

    onCancel(): void {
        this.router.navigate(['../../'], { relativeTo: this.route });
    }
}
